import {
  ReactionTypeT,
  StatusTypeT,
  type PatientAllergyT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

export interface AllergyRowModel {
  key: string;
  allergen: string;
  reaction: string;
  reactionType: string;
  status: string;
  onsetDate: string;
}

export interface AllergySearchResultModel {
  allergenId: number | null;
  name: string;
  allergenType: string;
  isActive: boolean;
  label: string;
}

export function formatAllergyCellValue(value: string | number | null | undefined): string {
  if (value === null || value === undefined) {
    return '—';
  }
  const text = String(value).trim();
  return text.length > 0 ? text : '—';
}

export function getAllergyRowKey(allergy: PatientAllergyT, index: number): string {
  return String(allergy.PatientAllergyId ?? `${allergy.AllergenId ?? 'allergen'}-${index}`);
}

export function toAllergyRowModel(allergy: PatientAllergyT, index: number): AllergyRowModel {
  return {
    key: getAllergyRowKey(allergy, index),
    allergen: formatAllergyCellValue(allergy.DisplayName),
    reaction: formatAllergyCellValue(allergy.Reaction),
    reactionType: formatAllergyCellValue(allergy.ReactionType),
    status: formatAllergyCellValue(allergy.StatusType),
    onsetDate: formatAllergyCellValue(allergy.OnsetDate),
  };
}

export function getAllergyQualifierLabels(allergy: PatientAllergyT): string[] {
  const labels: string[] = [];

  if (allergy.ReactionType === ReactionTypeT.AdverseReaction) {
    labels.push('Adverse reaction');
  }

  if (allergy.StatusType === StatusTypeT.Inactive) {
    labels.push('Inactive');
  } else if (allergy.StatusType === StatusTypeT.Deleted) {
    labels.push('Deleted');
  }

  return labels;
}

export function toAllergySearchResultModel(result: {
  AllergenId?: number | null;
  Name?: string | null;
  BrandName?: string | null;
  AllergenType?: string | null;
  IsActive?: boolean | null;
}): AllergySearchResultModel {
  const name = String(result.Name ?? '').trim();
  const brand = String(result.BrandName ?? '').trim();
  const allergenType = String(result.AllergenType ?? '—');
  const isActive = Boolean(result.IsActive ?? false);
  const label = brand.length > 0 && brand !== name ? `${name} (${brand})` : name || brand || '—';

  return {
    allergenId: result.AllergenId ?? null,
    name: name || brand || '—',
    allergenType,
    isActive,
    label,
  };
}
